import type { ProximityBleBridge } from './bleBridge';

/** Static device capability — resolved once per app runtime, never from format/render paths. */
let deviceUwbSupported: boolean | null = null;
let deviceUwbSupportedPromise: Promise<boolean> | null = null;

export function getCachedDeviceUwbSupported(): boolean | null {
  return deviceUwbSupported;
}

/** Reset only for unit tests. */
export function resetDeviceUwbSupportedCache(): void {
  deviceUwbSupported = null;
  deviceUwbSupportedPromise = null;
}

export function resolveDeviceUwbSupported(bridge: ProximityBleBridge): Promise<boolean> {
  if (deviceUwbSupported !== null) {
    return Promise.resolve(deviceUwbSupported);
  }
  if (!deviceUwbSupportedPromise) {
    deviceUwbSupportedPromise = bridge
      .isUwbAvailable()
      .then(({ supported }) => {
        deviceUwbSupported = supported === true;
        return deviceUwbSupported;
      })
      .catch(() => {
        deviceUwbSupported = false;
        return false;
      });
  }
  return deviceUwbSupportedPromise;
}
